<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Настройки накладных</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <h6>Сабстатусы</h6>
            <div class="input-group" v-for="s in [...($invoiceSubStatuses || []), ...newRecords]">
              <input v-model="s.id" type="number" disabled class="form-control">
              <input v-model="s.title" type="text" class="form-control">
              <select v-model="s.store_id" :disabled="!newRecordsIds[s.id]" class="form-control">
                <option v-for="store in $AllStores" :value="store.id">{{ store.title }}</option>
              </select>
            </div>
            <div class="mt-1 flex justify-content-between">
              <button @click="addNewRecord" class="btn btn-default">Добавить сабстатус</button>
              <LoadingButton
                title="Сохранить"
                :loading="btnLoading"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => updateRecords()"
                className="btn btn-outline-success"
              />
            </div>
          </div>
        </div>
        <!--        <template v-else>-->
        <!--          <pulse-loader :loading="true" :color="$constants.LOADING_COLOR" class="text-center"/>-->
        <!--        </template>-->
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  components: {
    LoadingButton,
  },
  data() {
    return {
      btnLoading: false,
      newRecords: [],
      newRecordsIds: {},
    }
  },
  computed: {
    $invoiceSubStatuses() {
      return this.$store.getters['invoices/subStatuses'];
    },
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  methods: {
    addNewRecord() {
      const arr = [...this.$invoiceSubStatuses, ...this.newRecords];
      const max = Math.max(...arr.map(o => +o.id));
      this.newRecords.push({id: max + 1, title: null, store_id: 2});
      this.newRecordsIds[max + 1] = true;
    },
    async updateRecords() {
      this.btnLoading = true;
      const statuses = [...this.$invoiceSubStatuses, ...this.newRecords].filter((r) => r.title);
      const {data} = await api.post('/settings/updateSettingsByType', {
        type: 'invoiceSubStatuses',
        records: statuses,
      })
      if (data.success) {
        toastr['success']('Сохранено');
        this.$store.dispatch('invoices/setSubStatuses', statuses);
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.btnLoading = false;
    }
  }
}

</script>

<style scoped>
.input-group select {
  width: 150px;
}

.input-group input:nth-of-type(1) {
  width: 50px;
}

.input-group input:nth-of-type(2) {
  width: calc(100% - 200px);
}

</style>
